import { render, staticRenderFns } from "./AppSelectionBtns.vue?vue&type=template&id=15431648&"
import script from "./AppSelectionBtns.vue?vue&type=script&lang=js&"
export * from "./AppSelectionBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports